import { createFileRoute } from '@tanstack/react-router';
import { CompanySettingsIndex } from '@/pages/settings/CompanySettingsIndex';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/settings/company')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['companySettings.manageProfile'] }),
	component: CompanySettingsIndex,
});
